import { jsx as _jsx } from "react/jsx-runtime";
const Bluetooth = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M7 15.68V9.18001L3.89 12.18L3.19 11.46L6.78 8.00001L3.19 4.53001L3.89 3.81001L7 6.82001V0.320007L11.58 4.75001L8.22 8.00001L11.58 11.25L7 15.68ZM8 9.18001V13.32L10.14 11.25L8 9.18001ZM8 2.68001V6.82001L10.14 4.75001L8 2.68001Z" }) })));
Bluetooth.iconName = "bluetooth";
Bluetooth.iconCategory = "Connectivity";
export default Bluetooth;
